import CompanyGalleryWidget from '@/components/gallery/CompanyGalleryWidget';
import { ICompany } from '@/types/models';
import { Box } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardTitleWrapper } from '@/pages/dashboard/DashboardWorkspace/component';

interface DashboardGalleryWidgetProps {
  company: ICompany;
}

const DashboardGalleryWidget: React.FC<DashboardGalleryWidgetProps> = ({
  company,
}) => {
  const navigate = useNavigate();

  const images = (company.gallery ?? [])
    .slice()
    .sort((a, b) => a.position - b.position)
    .map((g) => g.urlImg);

  return (
    <Box
      onClick={() => navigate('/moments')}
      sx={{ cursor: 'pointer', marginBottom: '15px' }}
    >
      <DashboardTitleWrapper>
        <Box className="title">Moments</Box>
      </DashboardTitleWrapper>
      <CompanyGalleryWidget images={images} compact readOnly />
    </Box>
  );
};

export default DashboardGalleryWidget;
